export default __webpack_public_path__ + "static/media/gc-green-white@2x.d51f642b.png";